<div class="modal-header">
    <button class="btn-close" (click)="bsModalRef.hide()">
        <span></span>
        <span></span>
    </button>
</div>
<div class="modal-body">
    <div class="container">
        <div class="row">
            <div class="col-xs-12">
                <div class="col-md-6">
                    <h2 class="product-family">{{product.familyName}}</h2>
                    <h1 class="product-name">{{product.name}} <ng-container *ngIf="product.level">({{product.size}})
                        </ng-container>
                    </h1>
                </div>
                <div class="col-md-6">
                    <img class="img-product pull-right" [src]="product.avatar|absolutePath:'products'"
                        (load)="loadAvatar=true" alt="{{product.name}} en livraison">
                </div>
            </div>
        </div>
        <div class="row" *ngIf="loading">
            <div class="col-md-12">
                <div class="placeholder">
                    <div class="animated-background"></div>
                </div>
                <div class="placeholder2">
                    <ng-container *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]">
                        <div class="animated-background"></div>
                    </ng-container>
                </div>
            </div>
        </div>
        <ng-container *ngIf="!loading">
            <div class="row margin">
                <div class="col-xs-12">
                    <div class="all">
                        <div class="compositions">
                            <p class="unavailableIng" *ngIf="unavComp>0 || unavOpt>0 || unavSupp>0">
                                <i class="flaticon-exclamation "></i> : Ingredient indisponible pour le
                                moment
                            </p>
                            <ul class="ul-comp">
                                <li *ngIf="product.compositions?.length>0">
                                    <p>
                                        <span class="span-com">
                                            Compositions :
                                        </span>
                                    </p>
                                    <div style="float: none;">
                                        <div class="check-group" *ngFor="let comp of product.compositions;let i=index"
                                            id="wTooltipComp{{i}}">
                                            <onoffswitch [(ngModel)]="comp.checked" [label]="comp.text"
                                                [available]="comp.available" placement="bottom"
                                                containerClass="customClass">
                                            </onoffswitch>
                                        </div>
                                    </div>
                                </li>
                                <li *ngIf="product.maxNbrIngOptions>0">
                                    <p>
                                        <ng-container *ngIf="(product.optionIngredients|groupByCategory).length>1">

                                            <span class="span-com">
                                                Options :
                                            </span>
                                        </ng-container>
                                        <ng-container *ngIf="(product.optionIngredients|groupByCategory).length==1">
                                            <span class="span-com">
                                                {{(product.optionIngredients|groupByCategory)[0].category}} :
                                                {{product.maxNbrIngOptions}} max
                                            </span>
                                        </ng-container>

                                    </p>
                                    <div class="text-gray">
                                        <div class="d-flex" style="margin: 0px 0px 10px 0px"
                                            *ngIf="product.obligatoryIngredient.length>0">
                                            <label>Obligatoire :</label>
                                            <label *ngFor="let ing of product.obligatoryIngredient">
                                                {{ing.category}} : {{ing.maxNbrIngOptions}} ingrédient(s)
                                            </label>
                                        </div>
                                    </div>
                                    <ul style="margin-left: 30px;">
                                        <li *ngFor="let c of product.optionIngredients|groupByCategory;let i=index">
                                            <div>
                                                <p class="p-color"
                                                    *ngIf="(product.optionIngredients|groupByCategory).length>1">
                                                    {{c.category}} :</p>
                                                <div class="d-grid">
                                                    <div class="check-group" *ngFor="let opt of c.elements;let i=index">
                                                        <onoffswitch (change)="changeOption(opt)"
                                                            [(ngModel)]="opt.checked" [label]="opt.text"
                                                            [disabled]="!opt.available || (optChecked==product.maxNbrIngOptions && !opt.checked)"
                                                            [available]="opt.available">
                                                        </onoffswitch>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                                <li *ngIf="product.hasSupp>0">
                                    <p>
                                        <span class="span-com">
                                            Supplément :
                                        </span>
                                    </p>
                                    <ul style="margin-left: 30px;">
                                        <li *ngFor="let c of product.supplements|groupByCategory;let i=index">
                                            <div>
                                                <p class="p-color">{{c.category}} :</p>
                                                <div class="check-group" *ngFor="let supp of c.elements;let i=index">
                                                    <onoffswitch [(ngModel)]="supp.checked" [label]="supp.text"
                                                        [available]="supp.available">
                                                    </onoffswitch>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-9">
                    <textarea placeholder="Commentaire" name="comment" id="comment" [(ngModel)]="product.comment"
                        rows="3"></textarea>
                </div>
                <div class="col-sm-3">
                    <button class="add-to-cart btn pull-right" (click)="valider()">
                        Valider
                    </button>
                </div>
            </div>
        </ng-container>
    </div>
</div>